import { AppUtils } from '../../utils/index';

export class StoredFileModel {
	private fileName: string;
	private fileSize: number;
	private fileGuid: string;

	set FileName(value: string) {
		this.fileName = value;
	}

	get FileName(): string {
		return this.fileName;
	}

	set FileSize(value: number) {
		this.fileSize = value;
	}

	get FileSize(): number {
		return this.fileSize;
	}

	set FileGuid(value: string) {
		this.fileGuid = value;
	}

	get FileGuid(): string {
		return this.fileGuid;
	}

	get RoundedFileSize(): number {
		if (this.fileSize > 1023) {
			return parseFloat((this.fileSize / 1024).toFixed(2));
		} else {
			return Math.round(this.fileSize);
		}
	}

	get FileUnit(): string {
		let fileUnit = 'KB';
		if (this.fileSize > 1023) {
			fileUnit = 'MB';
		}
		return fileUnit;
	}


	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): StoredFileModel {
		return AppUtils.Helper.createFromMap(dataObject, StoredFileModel);
	}
}